import React from "react";
import {
  Button,
  Col,
  Container,
  FormControl,
  FormLabel,
  Row,
} from "react-bootstrap";
import { BaseBean } from "../ds/client_ds.js";
import {
  CustomerSearchCriteria,
  FabricStyleSearchCriteria,
  PageListBean,
  PickTicketSearchCriteria,
  RestCustomerListRequest,
  RestFabricStyleListBeanRequest,
  RestPageListBean,
  RestPickTicketListRequest,
  RestReadRequest,
  RestSalesOrderListRequest,
  SalesOrderSearchCriteria,
} from "../ds/ds.js";
import { LookupHandler, LookupResultDetails } from "../ds/lookup_ds.js";
import { Eraser, TickIcon } from "../gui_components/Icons.js";
import {
  DatePickerComponent,
  InputTextbox,
  ShowError,
  ProgressBar,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { SalesOrderLookupHandler } from "../lookup/SalesOrderLookupHandler.js";
import { ModuleUtils } from "../modules/ModuleUtils.js";
import { CustomerService } from "../services/CustomerService.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { PickTicketService } from "../services/PickTicketService.js";
import { SalesOrderService } from "../services/SalesOrderService.js";
import { ConfigManager } from "../config/ConfigManager.js";
export class PickTicketLookupHandler extends LookupHandler {
  constructor(companyCode, attribute_name, status) {
    super();
    this.attribute_name = attribute_name;
    this.lookupTitle = attribute_name + " Lookup";
    this.companyCode = companyCode;
    this.status = status;
    let resetCriteria = new PickTicketSearchCriteria();
    resetCriteria.companyCode = companyCode;
    this.resetCriteria = resetCriteria;
    let newCriteria = new PickTicketSearchCriteria();
    newCriteria.companyCode = companyCode;
    this.newCriteria = newCriteria;
    let pickTicketLookupCriteria = new PickTicketSearchCriteria();
    pickTicketLookupCriteria.companyCode = this.companyCode;
    let lookupCriteriaView = PickTicketLookupCriteraHandler(
      companyCode,
      pickTicketLookupCriteria
    );
    let lookupDataCallback = function (
      lookup_dialog,
      page_number,
      searchCriteria,
      filterText
    ) {
      this.fetchDataFromService(
        lookup_dialog,
        page_number,
        searchCriteria,
        filterText
      );
    };
    this.setDetails(
      lookupDataCallback,
      pickTicketLookupCriteria,
      lookupCriteriaView
    );
    ModuleUtils.getPickTicketStatusList();
    this.initColumns();
  }
  initColumns() {
    this.addColumnDefinition(this.attribute_name, "code", 0, true); //1
    this.addColumnDefinition("PickTicketDate", "createdDate", 0, false); //3
    this.addColumnDefinition(" SalesOrder#", "salesOrderNumber", 0, false); //1
    this.addColumnDefinition("Customer", "customerCode", 0, false); //3
    this.addColumnDefinition("CustomerName", "customerName", 0, false); //3
    this.addColumnDefinition("Item", "fabricStyleCode", 0, false); //3
    this.addColumnDefinition(
      "CustPO#",
      "customerPurchaseOrderNumber",
      0,
      false
    ); //3
    this.addColumnDefinition("Status", "status", 0, false); //3
  }
  loadPickTicketList = (lookup_dialog, pageNumber, searchCriteria) => {
    let pt_criteria = new PickTicketSearchCriteria(); //To be fetched from CriteriaHandler
    pt_criteria.companyCode = this.companyCode;
    if (searchCriteria !== undefined && searchCriteria !== null) {
      pt_criteria.pickTicketStartsWith = searchCriteria.pickTicketStartsWith;
      pt_criteria.pickTicketContains = searchCriteria.pickTicketContains;
      pt_criteria.pickTicketCode = searchCriteria.pickTicketCode;
      pt_criteria.salesOrderNumber = searchCriteria.salesOrderNumber;
      pt_criteria.customerCode = searchCriteria.customerCode;
      pt_criteria.status = searchCriteria.status;
      pt_criteria.fabricStyleCode = searchCriteria.fabricStyleCode;
      pt_criteria.fabricStyleColorCode = searchCriteria.fabricStyleColorCode;
      pt_criteria.createdDate = searchCriteria.createdDate;
    }
    if (!isEmptyString(this.status)) {
      pt_criteria.status = this.status;
    }
    let pt_pageList = new PageListBean();
    pt_pageList.pageSize = 50; //TODO --> Fetch from Config
    pt_pageList.pageNumber = pageNumber;
    pt_pageList.currentPage = pageNumber;
    let pt_requestInput = new RestPickTicketListRequest();
    pt_requestInput.pageInput = pt_pageList;
    pt_requestInput.searchCriteria = pt_criteria;
    PickTicketService.getPickTicketPageList(
      pt_requestInput,
      (response) => this.loadPickTicketListResponse(response, lookup_dialog),
      this.loadPickTicketListError
    );
  };
  loadPickTicketListResponse = (response, lookup_dialog) => {
    let ptList = [];
    let totalCount = 0;
    let currentPageNumber = 0;
    let pageSize = 0;
    if (
      response.data.pickTicketPageList != null &&
      response.data.pickTicketPageList.pickTickets !== null
    ) {
      ptList = response.data.pickTicketPageList.pickTickets;
      totalCount = response.data.pickTicketPageList.totalCount;
      currentPageNumber = response.data.pickTicketPageList.currentPage;
      pageSize = response.data.pickTicketPageList.pageSize;
      ptList.map((pt) => {
        pt.status = ModuleUtils.getPickTicketStatusCaption(pt.status);
      });
    }
    let lookup_result_details = new LookupResultDetails();
    lookup_result_details.pageData = ptList;
    let total_count = 0;
    if (this.lookup_data != null) {
      total_count = this.lookup_data.length;
    }
    lookup_result_details.totalRecordsCount = totalCount;
    lookup_result_details.currentPageNumber = currentPageNumber;
    lookup_result_details.pageSize = pageSize;
    lookup_result_details.criteriaDisplayString = ""; //TODO
    lookup_dialog.updateResultCallBack(lookup_result_details);
  };
  loadPickTicketListError = (error) => {
    ShowError("Error : " + error);
  };
  fetchDataFromService(lookup_dialog, pageNumber, searchCriteria, filterText) {
    let search = { ...searchCriteria };
    if (search != null && search != "unDefined") {
      // if (isEmptyString(search.pickTicketContains)) {
      if (!isEmptyString(filterText)) {
        search.pickTicketContains = filterText;
        this.searchCriteria = new PickTicketSearchCriteria();
      }
    }
    if (lookup_dialog != null) {
      this.loadPickTicketList(lookup_dialog, pageNumber, search);
    }
  }
}
const PickTicketLookupCriteraHandler = (
  companyCode,
  pickTicketLookupCriteria
) => {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        searchCriteria: new PickTicketSearchCriteria(),
        customerPageListForAutoCompleteList: new Array(),
        fabricPageListForAutoCompleteList: new Array(),
        showAutoCompleteCustomerList: true,
        showAutoCompleteFabricList: true,
        salesPageListForAutoCompleteList: new Array(),
        showAutoCompleteSOList: true,
        is3PL: false,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      };
      this.criteriaLookupHandler = React.createRef();
      this.focusRef = React.createRef();
    }
    componentDidMount() {
      let searchCriteria = this.state.searchCriteria;
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
        this.state.is3PL = true;
        this.setState({
          is3PL: true,
        });
      }
      if (this.focusRef.current) this.focusRef.current.focus();
      this.initLookupHandlers();
    }
    initLookupHandlers = () => {
      let customerLookupHandler = new CustomerLookupHandler(
        companyCode,
        "Customer"
      );
      this.setState({ customerLookupHandler: customerLookupHandler });
      let fabricLookupHandler = new FabricStyleLookupHandler(
        companyCode,
        this.props.is3PL ? "Item" : "Fabric Style"
      );
      this.setState({ fabricLookupHandler: fabricLookupHandler });
      let salesOrderLookupHandler = new SalesOrderLookupHandler(
        companyCode,
        "salesOrderNumber"
      );
      this.setState({ salesOrderLookupHandler: salesOrderLookupHandler });
    };
    continueButtonClick = () => {
      this.props.searchCriteriaCallBack(this.state.searchCriteria);
    };
    onChange = (e) => {
      let temp_searchCriteria = this.state.searchCriteria;
      temp_searchCriteria[e.target.name] = e.target.value;

      this.setState({ searchCriteria: temp_searchCriteria });
    };
    clearCriteria = () => {
      let searchCriteria = new PickTicketSearchCriteria();
      searchCriteria.companyCode = companyCode;
      this.setState({
        searchCriteria: searchCriteria,
        isShowColorLookup: false,
        colorLookupHandler: null,
      });
      if (this.focusRef.current) this.focusRef.current.focus();
    };
    onContainerKeyDown = (e) => {
      if (e.ctrlKey && e.keyCode == "191") {
        this.continueButtonClick();
      }
    };
    onSalesOrderChange = (e) => {
      let salesOrder = e.target.value;
      this.state.showAutoCompleteSOList = true;
      let searchCriteria = this.state.searchCriteria;
      let showAutoCompleteList = this.state.showAutoCompleteSOList;
      if (isEmpty(salesOrder)) {
        this.state.showAutoCompleteSOList = false;
        let showAutoCompleteList = this.state.showAutoCompleteSOList;
        let searchCriteria = this.state.searchCriteria;
        searchCriteria.salesOrderNumber = "";
        let suggestion = [];
        this.setState({
          showAutoCompleteSOList: showAutoCompleteList,
          searchCriteria: searchCriteria,
          salesPageListForAutoCompleteList: suggestion,
        });
      } else if (
        e.target.name == "salesOrderNumber" &&
        showAutoCompleteList === true &&
        salesOrder !== ""
      ) {
        this.loadSalesBySearchString(e.target.value);
      }
      searchCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: searchCriteria });
    };
    loadSalesOrderDetail = (salesOrder) => {
      let readrestInput = new RestReadRequest();
      readrestInput.companyCode = companyCode;
      readrestInput.code = salesOrder;
      SalesOrderService.readSalesOrder(
        readrestInput,
        this.loadSalesOrderResponse,
        this.errorCallBack
      );
    };
    loadSalesOrderResponse = (response) => {
      if (response.data != null && response.data.salesOrder != null) {
        let searchCriteria = this.state.searchCriteria;
        const salesOrder = response.data.salesOrder;
        searchCriteria.salesOrderNumber = salesOrder.code;
        this.setState({
          searchCriteria: searchCriteria,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    };
    loadSalesBySearchString(searchString) {
      let searchsearchCriteria = new SalesOrderSearchCriteria();
      searchsearchCriteria.companyCode = companyCode;
      searchsearchCriteria.salesOrderNumberStartsWith = searchString;
      searchsearchCriteria.salesOrderNumberContains = searchString;
      let pageList = new PageListBean();
      pageList.pageSize = 100;
      let input = new RestSalesOrderListRequest();
      input.companyCode = companyCode;
      input.pageInput = pageList;
      input.code = searchString;
      input.searchCriteria = searchsearchCriteria;
      SalesOrderService.getSalesOrderPageList(
        input,
        this.loadBySalesOrderResponse,
        this.errorCallBack
      );
    }
    loadBySalesOrderResponse = (response) => {
      if (
        response.data.salesOrderPageList != null &&
        response.data.salesOrderPageList.salesOrders !== null
      ) {
        let salesData = response.data.salesOrderPageList.salesOrders;
        let simpleAutoCompleteList = new Array();
        if (salesData.length > 0 && salesData != null) {
          salesData.map((salesCode) => {
            let simpleItemBean = {
              code: salesCode.code,
              description: "",
            };
            simpleAutoCompleteList.push(simpleItemBean);
          });
        }
        this.setState({
          salesPageListForAutoCompleteList: simpleAutoCompleteList,
        });
      }
    };
    salesCodeEnterKeyEventHandler = (e) => {
      let salesCode = e.target.value;
      this.loadSalesOrderDetail(salesCode);
      this.setState({
        salesPageListForAutoCompleteList: new Array(),
        isShowProgressBarPopup: true,
        progressLoadingText: "Reading... ",
      });
    };
    displayAutoCompleteSalesList = (showAutoCompleteList) => {
      this.setState({ showAutoCompleteSOList: showAutoCompleteList });
    };
    fabricCodeOnChange = (e) => {
      let fabricStyleCode = e.target.value;
      this.state.showAutoCompleteFabricList = true;
      let tempCriteria = this.state.searchCriteria;
      let showAutoCompleteList = this.state.showAutoCompleteFabricList;
      if (isEmpty(fabricStyleCode)) {
        this.state.showAutoCompleteFabricList = false;
        let showAutoCompleteList = this.state.showAutoCompleteFabricList;
        let criteria = this.state.searchCriteria;
        criteria.fabricStyleCode = "";
        let suggestion = [];
        this.setState({
          showAutoCompleteFabricList: showAutoCompleteList,
          searchCriteria: criteria,
          fabricPageListForAutoCompleteList: suggestion,
        });
      } else if (
        e.target.name == "fabricStyleCode" &&
        showAutoCompleteList === true &&
        fabricStyleCode !== ""
      ) {
        this.readFabricBySearchString(e.target.value);
      }
      tempCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: tempCriteria });
    };
    readandsetFabricStyleDetailResponse = (response) => {
      let criteria = this.state.searchCriteria;
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
      if (response.data != null && response.data.fabricStyle != null) {
        let fabricStyle = response.data.fabricStyle;
        if (!isEmpty(fabricStyle)) {
          criteria.fabricStyleCode = fabricStyle.code;
          this.setState({
            searchCriteria: criteria,
          });
        }
      }
    };
    readandsetFabricStyleDetail = (fabricStyleCode) => {
      let input = new RestReadRequest();
      input.companyCode = companyCode;
      input.code = fabricStyleCode;
      FabricStyleService.readFabricStyle(
        input,
        this.readandsetFabricStyleDetailResponse,
        this.errorCallBack
      );
    };

    readFabricBySearchString(searchString) {
      let searchCriteria = new FabricStyleSearchCriteria();
      searchCriteria.companyCode = companyCode;
      searchCriteria.fabricStyleCodeStartsWith = searchString;
      searchCriteria.fabricStyleNameStartsWith = searchString;
      let pageList = new RestPageListBean();
      pageList.pageSize = 100;
      let input = new RestFabricStyleListBeanRequest();
      input.companyCode = companyCode;
      input.pageInput = pageList;
      input.code = searchString;
      input.searchCriteria = searchCriteria;
      FabricStyleService.getActiveFabricStylesForAutoComplete(
        input,
        this.readByFabricCodeResponse,
        this.errorCallBack
      );
    }
    readByFabricCodeResponse = (response) => {
      let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
      let simpleAutoCompleteList = new Array();
      if (fabricStyleData.length > 0 && fabricStyleData != null) {
        fabricStyleData.map((fabricStyle) => {
          let simpleItemBean = {
            code: fabricStyle.fabricStyleCode,
            description: fabricStyle.fabricStyleName,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      this.setState({
        fabricPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    };
    fabricEnterKeyEventHandler = (e) => {
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Reading ...",
      });
      this.readandsetFabricStyleDetail(e.target.value);
      this.setState({ fabricPageListForAutoCompleteList: new Array() });
    };
    displayAutoCompleteFabricList = (showAutoCompleteFabricList) => {
      this.setState({ showAutoCompleteFabricList: showAutoCompleteFabricList });
    };
    customerCodeOnChange = (e) => {
      let customerCode = e.target.value;
      this.state.showAutoCompleteCustomerList = true;
      let tempCriteria = this.state.searchCriteria;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      if (isEmpty(customerCode)) {
        this.state.showAutoCompleteCustomerList = false;
        let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
        let criteria = this.state.searchCriteria;
        criteria.customerCode = "";
        let suggestion = [];
        this.setState({
          showAutoCompleteCustomerList: showAutoCompleteList,
          searchCriteria: criteria,
          customerPageListForAutoCompleteList: suggestion,
        });
      } else if (
        e.target.name == "customerCode" &&
        showAutoCompleteList === true &&
        customerCode !== ""
      ) {
        this.readCustomerBySearchString(e.target.value);
      }
      tempCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: tempCriteria });
    };
    readCustomer = (customerCode) => {
      let input = new RestReadRequest();
      input.companyCode = companyCode;
      input.code = customerCode;
      CustomerService.readCustomer(
        input,
        this.editCustomerResponse,
        this.errorCallBack
      );
    };
    editCustomerResponse = (response) => {
      if (response.data.customer != null) {
        let customerData = response.data.customer;
        let criteria = this.state.searchCriteria;
        criteria.customerCode = customerData.code;
        this.setState({ searchCriteria: criteria });
      }
    };
    readCustomerBySearchString(searchString) {
      let searchCriteria = new CustomerSearchCriteria();
      searchCriteria.companyCode = companyCode;
      searchCriteria.customerCodeStartsWith = searchString;
      searchCriteria.customerNameContains = searchString;
      let cust_pageList = new RestPageListBean();
      cust_pageList.pageSize = 100;
      let cust_requestInput = new RestCustomerListRequest();
      cust_requestInput.pageInput = cust_pageList;
      cust_requestInput.searchCriteria = searchCriteria;
      CustomerService.getCustomerPageList(
        cust_requestInput,
        this.readByCustomerCodeResponse,
        this.errorCallBack
      );
    }
    readByCustomerCodeResponse = (response) => {
      let customerData = response.data.customerPageList.customers;
      let simpleAutoCompleteList = new Array();
      if (customerData.length > 0 && customerData != null) {
        customerData.map((customer) => {
          let simpleItemBean = {
            code: customer.code,
            description: customer.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      this.setState({
        customerPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    };
    errorCallBack = (error) => {
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
      ShowError(error);
    };
    customerCodeEnterKeyEventHandler = (e) => {
      let customerCode = e.target.value;
      this.readCustomer(customerCode);
      this.setState({
        customerPageListForAutoCompleteList: new Array(),
      });
    };
    displayAutoCompleteList = (showAutoCompleteList) => {
      this.setState({
        showAutoCompleteCustomerList: showAutoCompleteList,
      });
    };
    render() {
      let searchCriteria = this.state.searchCriteria;
      const is3PL = this.state.is3PL;
      return (
        <div>
          <ProgressBar
            progressLoadingText={this.state.progressLoadingText}
            isShowPopup={this.state.isShowProgressBarPopup}
          />
          <Container onKeyDown={this.onContainerKeyDown}>
            <Row>
              <Col sm={5}>
                <FormLabel>PickTicket Starts With</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="pickTicketStartsWith"
                  name="pickTicketStartsWith"
                  onChange={this.onChange}
                  value={searchCriteria.pickTicketStartsWith}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>PickTicket Contains</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="pickTicketContains"
                  name="pickTicketContains"
                  onChange={this.onChange}
                  value={searchCriteria.pickTicketContains}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>PickTicket#</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="pickTicketCode"
                  name="pickTicketCode"
                  onChange={this.onChange}
                  value={searchCriteria.pickTicketCode}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Status</FormLabel>
              </Col>
              <Col sm={7}>
                <FormControl
                  as="select"
                  custom
                  onChange={this.onChange}
                  name="status"
                  value={searchCriteria.status}
                >
                  <option value={""}></option>
                  <option value={"P"}>Picked</option>
                  <option value={"K"}>Partially Picked</option>
                  <option value={"F"}>Invoiced / Finished</option>
                  <option value={"I"}>Partially Invoiced</option>
                  <option value={"X"}>Cancelled</option>
                </FormControl>
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Customer</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="customerCode"
                  name="customerCode"
                  onChange={this.customerCodeOnChange}
                  value={searchCriteria.customerCode}
                  lookupRequired={true}
                  lookupHandler={this.state.customerLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.customerCodeEnterKeyEventHandler}
                  autoCompleteListData={
                    this.state.customerPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCompleteList}
                  showAutoCompleteList={this.state.showAutoCompleteCustomerList}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                {is3PL ? (
                  <FormLabel>Item</FormLabel>
                ) : (
                  <FormLabel>FabricStyle#</FormLabel>
                )}
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="fabricStyleCode"
                  name="fabricStyleCode"
                  value={searchCriteria.fabricStyleCode}
                  onChange={this.fabricCodeOnChange}
                  lookupRequired={true}
                  lookupHandler={this.state.fabricLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.fabricEnterKeyEventHandler}
                  autoCompleteListData={
                    this.state.fabricPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCompleteFabricList}
                  showAutoCompleteList={this.state.showAutoCompleteFabricList}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>SalesOrder#</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="salesOrderNumber"
                  name="salesOrderNumber"
                  value={searchCriteria.salesOrderNumber}
                  onChange={this.onSalesOrderChange}
                  lookupRequired={true}
                  lookupHandler={this.state.salesOrderLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.salesCodeEnterKeyEventHandler}
                  autoCompleteListData={
                    this.state.salesPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCompleteSalesList}
                  showAutoCompleteList={this.state.showAutoCompleteSOList}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Created Date</FormLabel>
              </Col>
              <Col sm={7}>
                <DatePickerComponent
                  tabIndex={-1}
                  id="createdDate"
                  name="createdDate"
                  onChange={this.onChange}
                  value={searchCriteria.createdDate}
                />
              </Col>
            </Row>
            <div className="popup_criteria_button_align-lookup">
              <Button
                ref={this.focusRef}
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.continueButtonClick}
              >
                <TickIcon />
                Continue
              </Button>
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.clearCriteria}
              >
                <Eraser />
                Clear
              </Button>
            </div>
          </Container>
        </div>
      );
    }
  };
};
